export default __webpack_public_path__ + "static/media/success-icon.e87b02ab.svg";